import { ToastType } from 'react-toastify';

import { showToast } from '@shared/components/messages-and-errors/ToastsNotifications';
import { createMiddleware } from '@shared/redux';

import { getErrorKey } from '@shared/utils/errors';
import { getObjectSelectedClient } from '@domain/object-selected';
import {
    VTEX_SAVE_INTEGRATION_REQUEST_SUCCESS,
    VTEX_SAVE_INTEGRATION_REQUEST_ERROR,
    VTEX_GET_DATA_REQUEST_ERROR,
} from './vtex.state';

import { API_FAIL_DEFAULT_OP_MESSAGE, API_SUCCESS_OP_MESSAGE } from './vtex.constants';
import { getActiveIntegrationsAction } from '../integrations-list/integrations-list.state';

const defaultToastProps = {
    autoClose: 2000, toastId: 'vtex-toast', height: 300,
};

export const vtexMiddleware = createMiddleware({
    [VTEX_GET_DATA_REQUEST_ERROR]: (_, action) => {
        const message = getErrorKey(action.payload.response, API_FAIL_DEFAULT_OP_MESSAGE);

        showToast(message, ToastType.ERROR, {
            ...defaultToastProps,
            toastId: 'vtex-get-data-error',
        });
    },
    [VTEX_SAVE_INTEGRATION_REQUEST_ERROR]: (_, action) => {
        const message = getErrorKey(action.payload.response, API_FAIL_DEFAULT_OP_MESSAGE);

        showToast(message, ToastType.ERROR, {
            ...defaultToastProps,
            toastId: 'vtex-save-error',
        });
    },
    [VTEX_SAVE_INTEGRATION_REQUEST_SUCCESS]: (state) => {
        const { id } = getObjectSelectedClient(state);

        showToast(API_SUCCESS_OP_MESSAGE, ToastType.SUCCESS, defaultToastProps);

        return getActiveIntegrationsAction(id);
    },
});
